// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-status[data-v-8845583a] {\n  display: inline-flex;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/whatsapp-managment/includes/components/MessageStatus.vue"],"names":[],"mappings":"AACA;EACI,oBAAA;AAAJ","sourcesContent":["\n.message-status{\n    display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
